export default __webpack_public_path__ + "static/media/front-end-guild-badge.5df42ac6.png";